import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { FieldInputType, LenderFieldMap } from '@trnsact/trnsact-shared-types';
import { LenderMappingsFormValues } from '../types';
import { sanitizeFormKey } from '../lib';

export function useCategoryStats(fields: LenderFieldMap[]) {
  const { control } = useFormContext<LenderMappingsFormValues>();

  const lenderProperties = useMemo(() => fields.map(f => f.lenderProperty!), [fields]);

  const watchNames = useMemo(
    () => lenderProperties.map(prop => `mappingsByLenderProperty.${sanitizeFormKey(prop)}.mappedValue` as const),
    [lenderProperties]
  );

  const values = useWatch({ control, name: watchNames });

  return useMemo(() => {
    const requiredFields = fields.filter(f => f.details?.required === 'REQUIRED');
    const isFilled = (_: LenderFieldMap, i: number) => {
      const v = values[i];

      if (_.details?.fieldInputType === FieldInputType.OptionSet) {
        if (_.details?.optionSets?.length) {
          const selectedOption = _.details.optionSets.find(option => option?.lenderValue === v);
          return !!selectedOption;
        }
      }

      return !!v || v === 0;
    };

    return {
      total: fields.length,
      requiredTotal: requiredFields.length,
      filled: fields.filter(isFilled).length,
      requiredFilled: requiredFields.filter(f => {
        const idx = fields.indexOf(f);
        return isFilled(f, idx);
      }).length,
    };
  }, [fields, values]);
}
